import {createContext, useContext} from "react";
import {ICorrectiveSubsectionContextProps} from "../models/CorrectiveSubsectionModels";

const initialContextProps: ICorrectiveSubsectionContextProps = {
  itemDetail: {},
  setItemDetail: () => {},
  isView: false,
};

const CSContext = createContext<ICorrectiveSubsectionContextProps>(initialContextProps);

const CSProvider = CSContext.Provider;

const useCSContext = () => useContext(CSContext);

export {CSProvider, useCSContext};
